export default __webpack_public_path__ + "static/media/single-project-page-01-img9.99bed5f8.jpg";